import { THEME } from '@lyon/utils/theme';
import { ToasterOverrides, ToastOverrides } from 'baseui/toast';

export const TOAST: ToasterOverrides = {
  ToastBody: {
    style: {
      position: 'relative',
      width: '50vw',
      backgroundColor: THEME.colors.primary500,
      borderRadius: '10px',

      [THEME.media.small]: {
        width: '90vw',
      },
    },
  },
};

export const TOASTER: ToastOverrides = {
  Body: {
    style: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  InnerContainer: {
    style: {
      width: '100%',
    },
  },
  CloseIcon: {
    style: {
      marginRight: '16px',
      marginLeft: '16px',
      scale: 1.5,
    },
  },
};
